<!--
 * @Description: 排行榜
 * @Author:
 * @Date: 2020-08-07 11:46:42
 * @LastEditTime: 2020-10-14 15:58:32
 * @LastEditors: DTER6
-->

<template>
    <div class="ranking">
        <div class="ranking_top">
            <el-select v-model="trainClassSelect" class="ranking_top-select">
                <el-option :label="item.tsName" :value="item.id" v-for="item in classList" :key="item.id"></el-option>
            </el-select>
            <div class="ranking_top-head">
                <div class="ranking_top-head--div">
                    <p class="ranking_top-head-blue">{{myRank.enterSort}}</p>
                    <p class="ranking_top-head-666">排名</p>
                </div>
                <div class="ranking_top-head--div">
                    <img class="ranking_top-head--img" :src="headUrl" />
                    <p class="ranking_top-head-name">{{myRank.realName}}</p>
                </div>
                <div class="ranking_top-head--div">
                    <p class="ranking_top-head-blue">{{parseTime(myRank.chapterStudyTime)}}</p>
                    <p class="ranking_top-head-666">学习总时长</p>
                </div>
            </div>
        </div>
        <div class="ranking_main">
            <div class="ranking_main-content">
                <Nothing :show="rankingList"></Nothing>
                <el-row v-for="(item, index) in rankingList" :key="index" class="ranking_main-content--single">
                    <el-col :span="8">
                        <img v-if="item.topIndex === 1" src="@/assets/champion.png" />
                        <img v-if="item.topIndex === 2" src="@/assets/silver.png" />
                        <img v-if="item.topIndex === 3" src="@/assets/copper.png" />
                        <span v-if="item.topIndex > 3">{{item.topIndex}}</span>
                    </el-col>
                    <el-col :span="8">{{item.realName}}</el-col>
                    <el-col :span="8">{{parseTime(item.chapterStudyTime)}}</el-col>
                </el-row>
            </div>
            <div class="ranking_main-pagination">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            trainClassSelect: null,
            classList: [],
            enterpriseId: "",
            seatMealCorseIds: "",
            yearStart: "",
            yearEnd: "",
            myRank: {},
            userName: sessionStorage.userName,
            rankingList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            headUrl: "",
        }
    },
    watch: {
        trainClassSelect (v) {
            this.getAllCourse()
            this.handleCurrentChange(1)
        },
    },
    created () {
        if (sessionStorage.token === "" || sessionStorage.token === undefined) {
            this.$message.info("请先登录")
            this.$router.push("/login")
        }
        this.getNearYear()
        this.getEnterpriseId()
    },
    mounted () {
        this.headUrl = sessionStorage.headUrl
    },
    methods: {
        handleSizeChange (val) {
            this.pageSize = val
            this.getRankingList()
            this.getMyRank()
        },
        handleCurrentChange (val) {
            this.currentPage = val
            this.getRankingList()
            this.getMyRank()
        },
        dateFormat (time) {
            var date = new Date(time)
            var year = date.getFullYear()
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
            return year + "-" + month + "-" + day
        },
        getNearYear () {
            let end
            let start
            end = new Date()
            start = new Date()
            end = end.setTime(end.getTime() - 3600 * 1000 * 24)
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 366)
            start = this.dateFormat(start)
            end = this.dateFormat(end)
            this.yearStart = start
            this.yearEnd = end
            this.getTrainClass()
        },
        async getTrainClass () {
            let { code, data } = await this.ScoreAnalysisApi.getTrainClassStudyInfoByParams({
                studentId:sessionStorage.userUuid,
                pageNumber: 1,
                pageSize: 999999999,
            })
            if (code === "200") {
                this.classList = data.list
                this.classList.unshift({ id:null, tsName: "常规课程" })
            }
        },
        getEnterpriseId () {
            // this.$ajax
            //     .post(
            //         "/enterprise-service/Enterprise/getEnterByEnterNumber",
            //         this.postData({
            //             enterpriseNum: localStorage.enterpriseNum,
            //         })
            //     )
            //     .then((res) => {
            //         this.enterpriseId = res.data.id
            //         this.getAllCourse()
            //     })
                    this.getAllCourse()
        },
        getAllCourse () {
            this.$ajax.get(`studyapp-service/courseApp/getAllCourseIds`).then((res) => {
            // this.$ajax.get(`/enterprise-service/Setmeal/getEnterAndSetmealByEnterpriseId?enterpriseId=${this.enterpriseId}`).then((res) => {
                if (res.code === "200") {
                    // this.seatMealCorseIds = res.data[0].seatMealCourseId
                    this.seatMealCorseIds = res.data
                    this.getMyRank()
                    this.getRankingList()
                }
            })
        },
        async getMyRank () {
            let res = await this.StudyappServiceApi.getUserRankList({
                trainClassId: this.trainClassSelect,
                seatMealCorseIds: this.seatMealCorseIds,
                // start: this.yearStart,
                // end: this.yearEnd,
                userId: sessionStorage.userUuid,
                ifForever:this.trainClassSelect?'':1
            })
            if (res.code === "200") {
                this.myRank = res.data
            }
        },
        async getRankingList () {
            let res = await this.StudyappServiceApi.getEnterUserRankList({
                trainClassId: this.trainClassSelect?this.trainClassSelect:'',
                seatMealCorseIds: this.seatMealCorseIds,
                pageSize: this.pageSize,
                pageNumber: this.currentPage,
                // start: this.yearStart,
                // end: this.yearEnd,
                ifForever:this.trainClassSelect?'':1
            })
           
            if (res.code === "200") {
                this.rankingList = res.data.list.map(el=>{
                    el.topIndex = el.top + 10*(this.currentPage - 1)
                    return el
                })
                this.total = res.data.totalCount
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.ranking {
    width: 1020px;
	height: 100%;
	background: url("~@/assets/paihangbang.png") #fff no-repeat;
    margin-left: 35px;
	&_top {
		padding: 20px 0 10px;
		&-select {
			margin: 0 0 60px 25px;
			width: 260px;
		}
		&-head {
			width: 707px;
			height: 115px;
			// padding: 0 88px;
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			align-items: flex-end;
			text-align: center;
			background: #ffffff;
			box-shadow: 1px 3px 15px 0px rgba(4, 0, 0, 0.2);
			border-radius: 10px 10px 0px 0px;
			&--div {
				width: 33%;
				margin-bottom: 24px;
			}
			&--img {
				width: 110px;
                height: 110px;
                border-radius: 55px;
				// min-height: 80px;
				background-color: white;
				margin-bottom: 18px;
			}
			&-blue {
				margin: 0 0 15px 0;
				font-size: 30px;
				color: #2a7ac4;
			}
			&-666 {
				margin: 0;
				font-size: 16px;
				color: #666;
			}
			&-name {
				margin: 0;
				font-size: 20px;
                // font-weight: bold;
                font-family: Microsoft YaHei;
				color: #333;
			}
		}
	}
	&_main {
        &>img {
            width: 100%;
        }
		&-content {
			padding: 0 30px;
			&--single {
				padding: 0 150px;
				height: 46px;
				text-align: center;
				font-size: 16px;
				color: #666;
				border-bottom: 1px solid #eaeaea;
				border-right: 1px solid #eaeaea;
				border-left: 1px solid #eaeaea;
				display: flex;
				justify-content: space-around;
				align-items: center;
			}
		}
		&-pagination {
			margin-top: 16px;
			display: flex;
			justify-content: center;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/accountInfo/ranking.vue